import {Vue} from '~/addiesaas'
import createPersistedState from 'vuex-persistedstate'
import {parseNumber, alert, fv} from '../../lib/utils'
import { formatDate, parseDateTime, DateTime, Settings, time2Min} from '../../lib/dates'
Settings.defaultLocale = 'en-us'

import * as types from '../mutation-types/race'

import ProviderService from '../../services/provider'
import config from '../../lib/config'

export const raceType = 'race-reservations'

const {
  supercharged,
  DEFAULT_BOOKING_BUFFER: buffer,
  TIMEZONE: timezone,
  clubspeed: {
    taxes,
    products: {race_reservations = [], races = [], socks = []} = {},
    settings = {},
  },
  RACE_TEST_DEFAULTS = {},
  RACES_SETTINGS = {}
} = config

// set this true to namespace all getters, mutations, actions etc.
const namespaced = true
export const namespace = 'race'

const min = Math.min
const max = Math.max
const dayBreakTime = config.DAY_SPLIT
const holdDefault = {
  onlineBookingReservationsId: null,
  expiresAt: null,
  quantity: null,
  checkId: null,
  customersId: null,
  sessionId: '',
  createdAt: null,
  onlineBookingReservationStatusId: null,
}

const racerDetailsItem = {
  racerName: 'Participant',
  type: 'adult',
  quantity: 1,
  membership: '',
  guest: false,
}

// state
const state = {
  editItem: null,
  cartItems: {},
  settings: _.merge({}, {supercharged}, RACES_SETTINGS, {
    maxKarts: 12,
    groups: {
      [raceType]: {
        groupTitle: 'Race Reservations',
        editable: false,
        deletable: false,
        hidden: false,
        children: [],
        attributes: {
          skipCartCount: true
        }
      },
      races: {
        groupTitle: 'Points',
        editable: true,
        deletable: false,
        hidden: true,
        attributes: {
          skipCartCount: true
        }
      },
    },
    races: races,
    [raceType]: race_reservations,
    socksProducts: socks,
    selectedProduct: null
  }),
  allowSlotGrouping: false, // use this to group at front end by hour
  form: Object.assign({},
    {
        cartId: null,
        termsAgreed: 'no',
        termsSales: 'no',
        termsArrival: 'no',
        termsHeightAge: 'no',
        ageTermsAgreed: 'no',
        raceType: 'pro',
        raceTitle: 'Race',
        editRoute: null,

        racerDetails: [_.clone(racerDetailsItem)],

        racerRacesMatrix: [],

        numberOfAdults: null,
        numberOfHours: null,
        numberOfAdultRaces: 0, // = requiredRaces
        numberOfJuniorRaces: 0,
        numberOfTitaniumMembers: 0,
        selectedDate: null,// DateTime.local().toISODate(),
        selectedSlots: {}, // time, type, karts, selected, racers, tMembers
        raceSeparately: 'no',
        allowRaceSeparately: true,
        holdStartsAt: null,
        holdEndsAt: null,
        usePackages: false,
        hasGroupedSlots: true, // use this to book grouped slots at backend
        timezone,
        buffer,
        contact: {
          firstName: null,
          lastName: null,
          phone: null,
          email: null
      },
    }
    , RACE_TEST_DEFAULTS),
  productAccessories: {},
  retrievedSlots: {},
  retrievedAvailability: {},
  fetchingTimeslots: false,
  wasCarted: false,
  isHydrating: false,
  raceTypes: ['pro'], // ninja
}

const helpers = {
  getContact(data) {
    data = data || {}
    return {
      first_name: data.firstName,
      last_name: data.lastName,
      phone: data.phone,
      email: data.email
    }
  },
  prepareAccessoriesCartItems(items, parentId, settings, state, getters) {
    const type = 'accessories'

    let cartItems = _.reduce(items, (items, aItem, aId) => {

      const {count, product} = aItem
      const {product_id, location_id, tax_amount, title, price} = product

      if (!count) {
        return items
      }

      const total = price * count
      const editable = false
      const deletable = true
      const tax = tax_amount * count
      const date = DateTime.fromISO(getters.input('selectedDate')).toISODate()
      const uid = _.uniqueId((new Date()).valueOf() + '_')
      const id = _.filter([date.replace(/[:.]/g, '-'), product_id, location_id, uid]).join('_')

      const options = {
        id,
        total,
        count,
        tax,
        parentId
      }
      const attributes = {
        id,
        total,
        count,
        tax,
        product,
        parentId,
        localItem: aItem
      }

      const item = {
        id,
        title,
        type,
        total,
        payload: {
          product_id,
          count,
          options
        },
        editable,
        deletable,
        attributes
      }
      items[aId] = item
      return items
    }, {})

    return cartItems
  },
  prepareUniversalNinjaCartItems(items, settings, state, getters) {
    const type = raceType
    const date = DateTime.fromISO(getters.input('selectedDate')).toISODate()
    const editRoute = getters.input('editRoute')
    if (!date) {
      return {}
    }
    if (_.isEmpty(items)) {
      return {}
    }
    const {form: {hasGroupedSlots = false}} = state

    let cartItems = _.reduce(items, (items, slot, index) => {
      const {item: slotItem, racers: count} = slot
      const {product_id, reservationProduct: product, heatStartsAt: datetime} = slotItem
      const {meta = [], location_id, tax_amount, title, rate} = product
      if (!count) {
        return items
      }
      const total = rate * count
      const isEditDeletable = true || !state.allowSlotGrouping || slot.children.length
      const editable = isEditDeletable
      const deletable = isEditDeletable
      const tax = tax_amount * count
      const tierTotal = 0
      // const children = slot.children
      // const parent = slot.parent
      const {form, raceTypes} = state
      const uid = _.uniqueId((new Date()).valueOf() + '_')
      const id = _.filter([datetime.replace(/[:.]/g, '-'), product_id, location_id, uid]).join('_')
      const [raceType] = raceTypes

      const options = {
        id,
        total,
        count,
        tax,
        tierTotal,
        form,
        raceType: form.raceType,
        slot,
        contact: helpers.getContact(getters.input('contact'))
      }
      const attributes = {
        product,
        meta,
        tierTotal,
        form,
        raceType: form.raceType,
        slot,
      }

      const item = {
        id,
        title,
        type,
        total,
        groupTitle: type,
        payload: {
          product_id,
          count,
          options
        },
        editable,
        editRoute: {name: editRoute},
        deletable,
        attributes,
        useTimer: true,
        showWaiver: true
      }
      items[id] = item

      return items
    }, {})

    let groupParentId = null
    if (hasGroupedSlots) {
      cartItems = _.reduce(cartItems, (items, item, id) => {
        if (item.type === 'accessories') {
          return items
        }
        if (_.isEmpty(items)) {
          items = item
        }
        else {
          items.total += 1 * item.total
          items.payload.count += 1 * item.payload.count
          items.payload.options.total += 1 * item.payload.options.total
          items.payload.options.count = items.payload.count
          items.payload.options.tax += 1 * item.payload.options.tax
        }
        return items
      }, {})
      if (!_.isEmpty(cartItems)) {
        groupParentId = cartItems.id
        cartItems = {[groupParentId]: cartItems}
      }
    }
    else {
       const children = _.keys(_.pickBy(cartItems, ({attributes: {slot: {parent}}}) => !!parent))
       const parent = _.first(_.keys(_.pickBy(cartItems, ({attributes: {slot: {parent}}}) => !!children.length)))

      _.forOwn(cartItems || {}, item => {
        if (item.attributes.slot.children.length) {
          item.attributes.childItems = children
          item.payload.options.childItems = children
        } else {
          item.attributes.parent = parent
          item.payload.options.parent = parent
        }
      })
    }


    const accessories = JSON.parse(JSON.stringify(state.productAccessories || {}))
    if (!_.isEmpty(accessories)) {
      const accessoriesItems = helpers.prepareAccessoriesCartItems(accessories, groupParentId, settings, state, getters)
      _.forOwn(accessoriesItems || {}, (aItem, aId) => {
        accessories[aId].cartId = aItem.id
        cartItems[aItem.id] = aItem
        if (groupParentId) {
          cartItems[groupParentId].attributes.accessories = accessories
          cartItems[groupParentId].payload.options.accessories = accessories
        }
      })
    }

    return cartItems
  },
  prepareUniversalPackageCartItems(items, settings, state, getters) {

    const date = DateTime.fromISO(getters.input('selectedDate')).toISODate()
    const editRoute = getters.input('editRoute')
    if (!date) {
      return {}
    }
    if (_.isEmpty(items)) {
      return {}
    }

    const cartItems = _.reduce(items, (items, product) => {

      const {product_id, location_id, key, type, meta, amount: total, tax_amount, miniTitle, title, rate, quantity: count} = product
      if (!count) {
        return items
      }
      const isReservation = type === raceType
      // console.log({isReservation})
      const editable = isReservation
      const deletable = isReservation
      const uid = _.uniqueId((new Date()).valueOf() + '_')
      const id = _.filter([date.replace(/[:.]/g, '-'), product_id, location_id, key, uid]).join('_')

      const tax = tax_amount * count

      const {form} = state
      const options = {
        id,
        total,
        count,
        tax,
        contact: helpers.getContact(getters.input('contact'))
      }
      const attributes = {
        product,
        meta,
        skipCartCount: !isReservation
      }

      if (isReservation) {
        options.tax = 0
        options.total = 0
        options.form = form
        attributes.form = form
        options.raceType = form.raceType
        attributes.raceType = form.raceType
      }

      const item = {
        id,
        title,
        type,
        total: isReservation ? 0 : total,
        groupTitle: type,
        payload: {
          product_id,
          count,
          options
        },
        editable,
        editRoute: editable && {name: editRoute},
        deletable,
        attributes,
        useTimer: isReservation,
        showWaiver: isReservation,
        hidden: !isReservation
      }
      items[id] = item
      return items
    }, {})

    const children = _.keys(_.pickBy(cartItems, item => item.type !== raceType))

    const tierTotal = _.reduce(cartItems, (totals, item) => {
      if (item.type === 'races') {
        totals += ((1 * item.total || 0) || 0)
      }
      return totals
    }, 0)

    _.forOwn(cartItems || [], item => {
      if (item.type === raceType) {
        item.attributes.tierTotal = tierTotal
        item.payload.options.tierTotal = tierTotal
        item.attributes.childItems = children
        item.payload.options.childItems = children
      }
    })
    // console.log({cartItems})
    return cartItems
  },
  prepareUniversalCartItems(items, settings, state, getters) {
    // console.log({items, settings, state, getters})
    const isNinja = getters.input('raceType') === 'ninja'
    if (isNinja) {
      return helpers.prepareUniversalNinjaCartItems(items, settings, state, getters)
    }
    if (getters.input('usePackages')) {
      return helpers.prepareUniversalPackageCartItems(items, settings, state, getters)
    }

    const date = DateTime.fromISO(getters.input('selectedDate')).toISODate()
    if (!date) {
      return {}
    }
    const editRoute = getters.input('editRoute')
    const cartItems = _.reduce(items, (items, product) => {
      const {product_id, location_id, key, type, meta, amount: total, tax_amount, title, rate, quantity: count} = product
      if (!count) {
        return items
      }
      const isReservation = type === raceType
      const editable = isReservation
      const deletable = isReservation
      const uid = _.uniqueId((new Date()).valueOf() + '_')
      const id = _.filter([date.replace(/[:.]/g, '-'), product_id, location_id, key, uid]).join('-')

      const tax = tax_amount * count

      const {form} = state
      const options = {
        id,
        total,
        count,
        tax,
        contact: helpers.getContact(getters.input('contact'))
      }
      const attributes = {
        product,
        meta,
        skipCartCount: !isReservation
      }
      if (isReservation) {
        options.raceType = form.raceType
        attributes.raceType = form.raceType
        options.form = form
        attributes.form = form
      }

      const item = {
        id,
        title,
        type,
        total,
        groupTitle: type,
        payload: {
          product_id,
          count,
          options
        },
        editable,
        editRoute: editable && {name: editRoute},
        deletable,
        attributes,
        useTimer: isReservation,
        showWaiver: isReservation
      }
      items[id] = item
      return items
    }, {})

    return cartItems
  },

  getCartItem(data, options, settings, state, getters) {

    //    'id1': {
    //         id: 'id1',
    //         name: '',
    //         groupTitle: '',
    //         title: '',
    //
    //         amount: 0,
    //         rate: 0,
    //         tax: 0,
    //         quantity: 0,
    //
    //         description: '', // can be a function
    //
    //         editable: true,
    //         deletable: true,
    //
    //         parent: '',
    //         children: [''],
    //         onEdit: function () {},
    //         onDelete: function () {},
    //         onAdd: function () {},
    //         type: 'races', // memberships
    //
    //         subItems: [],
    //         showSubItems: false,
    //         showSubItemTitle: false,
    //         showSubItemAmount:true,
    //         showSubItemHeader:true,
    //         showSubItemQuantity:true,
    //         showSubItemRate:true,
    //         attributes: {}
    //     }

    const items = data.map(item => {
      const source = settings[item.type][item.key] || {}
      item.amount = source.rate * item.quantity
      item.points = source.p_points * item.quantity
      return Object.assign({}, source, item, options)

    })

    return items
  },
  getType(type) {
    const types = {
      'adult': 'adult',
    }
    type = type.replace(/~| race/ig, '').toLowerCase()
    return types[type] || types['adult']
  },
  getSubType(type) {
    const types = {
      'Adult Pole Qualifier': 'pole-qualifier',
    }
    return types[type] || ''
  },
  getMiniLabel(type) {
    const types = {
      'Adult Pole Qualifier': 'APQ',
    }
    return types[type] || helpers.getType(type)
  },
  slotTimeType(time) {
    if (time >= dayBreakTime) {
      return 'evening'
    }
    return 'day'
  },
  parseRetrievedTimeslots(data, productIds) {

    // const template = {
    //   "heatId": 479351,
    //   "heatDescription": "~Adult Race",
    //   "heatStartsAt": "2018-12-08T14:10:00.00",
    //   "heatSpotsTotalActual": 12,
    //   "heatSpotsAvailableCombined": 0,
    //   "heatSpotsAvailableOnline": 0,
    //   "heatTypeId": 6,
    //   "isPublic": true,
    //   "products": [{
    //     "onlineBookingsId": 56092,
    //     "price1": 20,
    //     "productDescription": "1 Kart Race (web)",
    //     "productsId": 3199,
    //     "productSpotsAvailableOnline": 0,
    //     "productSpotsTotal": 12,
    //     "productType": "ReservationItem"
    //   }]
    // }
    const timeslots = _.reduce(data, (slots, item) => {
      const {heatStartsAt, heatDescription, heatSpotsTotalActual, heatSpotsAvailableOnline} = item
      const date = DateTime.fromISO(heatStartsAt, {zone: timezone})
      const datetime = date.toString()
      const currentDate = formatDate(date, 'd MMMM yyyy')
      const time = formatDate(date, 'h:mm a')
      const time24 = formatDate(date, 'HH:mm')
      const originalProduct = item.products[0] || {}
      const originalProductId = originalProduct.productsId
      const onlineBookingsId = originalProduct.onlineBookingsId

      const reservationProduct = race_reservations[originalProductId]
      if (!reservationProduct) {
        return slots
      }

      const product_id = reservationProduct.product_id
      const arriveThresholds = _.mapValues(
        _.mapKeys(
          _.get(reservationProduct, 'meta.arrival_threshold', []),
          item => (((item || {}).day || '') + '').toLowerCase()
        ),
        'minutes'
      )

      item.originalProductId = originalProductId
      item.product_id = product_id
      item.reservationProduct = reservationProduct

      const productMatch = _.findIndex(productIds, id => (id * 1) === (1 * product_id)) >= 0
      if (!productMatch) {
        return slots
      }

      const slot = {
        item: item,
        bookingId: onlineBookingsId,
        sectionType: helpers.slotTimeType(time24),
        id: item.heatStartsAt + '_' + product_id,
        maxKarts: parseInt(heatSpotsTotalActual), //heatSpotsTotalActual

        type: helpers.getType(heatDescription),
        subType: helpers.getSubType(heatDescription),
        miniLabel: helpers.getMiniLabel(heatDescription),
        datetime,
        date: currentDate,
        time: time,
        timeAsNumber: time2Min(time),

        karts: parseInt(heatSpotsAvailableOnline),
        racers: 0,
        selected: false,

        hold: _.merge({}, holdDefault,  {onlineBookingsId}),
        adjacentDisable: false, // not used in supercharged
        visible: true, // for ninja
        selectable: true, // for ninja
        children: [],// for ninja
        parent: null,// for ninja

      }

      // add arrive-by time to slot
      const parsedDate = parseDateTime(date)
      const day = parsedDate.weekdayLong.toLowerCase()
      const dateKey = formatDate(parsedDate, 'yyyy-MM-dd')
      const offset = fv(
        arriveThresholds[dateKey],
        arriveThresholds[day],
        arriveThresholds['all'],
        0
      ) || 0

      slot.arriveByTime = null
      if (offset) {
        const offsetDate = slot.arriveBy = parsedDate.minus({minutes: offset})
        slot.arriveByTime = formatDate(offsetDate, 'h:mm a')
      }

      slots[time] = slot
      return slots

    }, {})

    const items = Object.values(timeslots || {})
    items.forEach((item, index) => {
      // item.prevItem = items[index -1] || null
      item.prevTime = (items[index -1] || {}).time
      item.prevType = (items[index -1] || {}).type
      item.nextTime = (items[index + 1] || {}).time
      item.nextType = (items[index + 1] || {}).type
      // item.nextItem = items[index + 1] || null
    })
    return timeslots
  },
  packageRacer({quantity}, {packages}) {
    const races = {};
    _.forOwn(packages, (bundledRaces) => {
      const count = parseInt('' + quantity / bundledRaces)
      quantity = quantity % bundledRaces
      if (count) {
        races[bundledRaces] = count
      }
    })
    return races
  },
}

// mutations
const mutations = {
  [types.USE_SLOT_GROUPING](state, isEnabled) {
   state.allowSlotGrouping = !!isEnabled
  },
  [types.ALLOW_RACE_SEPARATELY](state, isAllow) {
    Vue.set(state.form, 'allowRaceSeparately', isAllow)
  },
  [types.SET_RACE_TYPES](state, types) {
    if (_.isString(types)) {
      types = [types]
    }
    state.raceTypes = types
  },
  [types.SET_EDIT_ITEM](state, item) {
    Vue.set(state, 'editItem', item)
  },
  [types.SET_CARTED](state) {
    Vue.set(state, 'wasCarted', true)
  },
  [types.SET_INPUT](state, items) {
    _.forOwn(items, (value, key) => {
      if (key.includes('.')) {
        _.set(state.form, key, value)
      } else {
        Vue.set(state.form, key, value)
      }
    })
  },
  [types.SET_SETTING](state, items) {
    _.forOwn(items, (value, key) => {
      if (key.includes('.')) {
        _.set(state.settings, key, value)
      } else {
        Vue.set(state.settings, key, value)
      }
    })
  },
  [types.SET_TIMESLOT](state, item) {
    if (_.isEmpty(state.form.selectedSlots)) {
      Vue.set(state.form, 'selectedSlots', {})
    }
    Vue.set(state.form.selectedSlots, item.time, item)
  },
  [types.UNSET_TIMESLOT](state, item) {
    if (_.isEmpty(state.form.selectedSlots)) {
      Vue.set(state.form, 'selectedSlots', {})
    }
    Vue.delete(state.form.selectedSlots, item.time)
  },
  [types.SET_TIMESLOT_DATA](state, {time, key, value}) {
    if (_.isEmpty(state.form.selectedSlots)) {
      Vue.set(state.form, 'selectedSlots', {})
    }
    const slot = state.form.selectedSlots[time]
    if (slot) {
      Vue.set(state.form.selectedSlots[time], key, value)
    } else {
      // console.log("missing selected slot for " + time)
    }
  },
  [types.RETRIEVING_TIMESLOTS](state, payload) {
    Vue.set(state, 'fetchingTimeslots', payload)
  },
  [types.SET_RETRIEVED_TIMESLOTS](state, payload) {
    Vue.set(state, 'retrievedSlots', payload)
  },
  [types.SET_RETRIEVED_TIMESLOT_DATA](state, {time, key, value}) {
    const slot = state.retrievedSlots[time]
    if (slot) {
      Vue.set(state.retrievedSlots[time], key, value)
    }else {
      // console.log("missing retrieved slot for " + time)
    }
  },
  [types.SET_RETRIEVED_TIMESLOT_DATA_ITEMS](state, items) {
    _.forOwn(items, ({key, value, time}) => {
        Vue.set(state.retrievedSlots[time], key, value)
      }
    )
  },
  [types.SET_RETRIEVED_AVAILABILITY](state, payload) {
    Vue.set(state, 'retrievedAvailability', payload)
  },
  [types.CLEAN_TIMESLOTS](state, payload) {
    Vue.set(state.form, 'selectedSlots', {})
  },

  [types.SET_LOCAL_CART_ITEM](state, item) {
    Vue.set(state.cartItems, item.date || item.cartId, item)
  },
  [types.UNSET_LOCAL_CART_ITEM](state, item) {
    Vue.delete(state.cartItems, item.date || item.cartId)
  },
  [types.CLEAR_LOCAL_CART_ITEMS](state) {
    Vue.set(state, 'cartItems', {})
  },
  [types.IS_HYDRATING_DATA](state, isHydrating) {
    state.isHydrating = isHydrating !== false
  },
  [types.SET_PRODUCT_ACCESSORIES](state, payload) {
    Vue.set(state, 'productAccessories', payload)
  },
  [types.ADD_RACER_DETAILS_ITEM](state, data) {
    state.form.racerDetails.push(data || _.clone(racerDetailsItem))
  },
  [types.UPDATE_RACER_DETAILS_ITEM](state, {index, racer}) {
    Vue.set(state.form.racerDetails, index, racer)
  },
  [types.DELETE_RACER_DETAILS_ITEM](state, index) {
    Vue.delete(state.form.racerDetails, index)
  },
}

const actions = {
  allowToRaceSeparately({commit}, payload) {
    commit(types.ALLOW_RACE_SEPARATELY, payload)
  },
  setRaceTypes({commit}, payload) {
    commit(types.SET_RACE_TYPES, payload)
  },
  setRaceEditItem({commit}, payload) {
    commit(types.SET_EDIT_ITEM, payload)
  },
  setRaceInEditMode({commit}) {
    commit(types.SET_CARTED)
  },
  setInput({commit}, payload) {
    commit(types.SET_INPUT, payload)
  },
  setSetting({commit}, payload) {
    commit(types.SET_SETTING, payload)
  },
  async retrieveTimeslots({commit, dispatch, getters}, date) {
    commit(types.RETRIEVING_TIMESLOTS, true)
    let data = {}
    try {
      data = await ProviderService.getBookingAvailability(date)
    } catch (e) {
      alert('Unable to retrieve booking slots. Please try again!', {classes: 'text-danger'})
      return {}
    }

    commit(types.SET_RETRIEVED_AVAILABILITY, _.mapKeys(data, (value) => value.heatStartsAt))
    const productIds = getters.filteringRaceProductIds
    const timeslots = helpers.parseRetrievedTimeslots(data, productIds)
    dispatch('setRetrievedTimeslots', timeslots)
    commit(types.RETRIEVING_TIMESLOTS, false)
    return timeslots
  },
  setRetrievedTimeslots({commit}, payload) {
    commit(types.SET_RETRIEVED_TIMESLOTS, payload)
  },
  setRetrievedTimeslotDataItems({commit}, payload) {
    commit(types.SET_RETRIEVED_TIMESLOT_DATA_ITEMS, payload)
  },
  setRetrievedTimeslotData({commit}, payload) {
    commit(types.SET_RETRIEVED_TIMESLOT_DATA, payload)
  },
  cleanRetrievedTimeslots({dispatch}) {
    dispatch('setRetrievedTimeslots', {})
  },

  selectTimeslot({commit, dispatch, getters}, {time = null, children = [], racers = null, selected = null, parent = null}) {
    if (!time) {
      return
    }
    const slot = getters.getSelectedTimeslot(time)
    if (!slot) {
      commit(types.SET_TIMESLOT, getters.retrievedTimeslot(time))
    }

    if (racers) {
       dispatch('setTimeslotData', {time, key: 'racers', value: racers})
    }
    if (selected) {
       dispatch('setTimeslotData', {time, key: 'selected', value: selected})
    }
    dispatch('setTimeslotData', {time, key: 'children', value: children})
    dispatch('setTimeslotData', {time, key: 'parent', value: parent})

    _.forOwn(children || [], childTime => {
      const childPayload = {
        time: childTime,
        racers,
        selected,
        parent: time,
        children: []
      }
      dispatch('selectTimeslot', childPayload)
    })

  },
  deselectTimeslot({commit, dispatch, getters}, {time = null, children = []}) {
    if (!time) {
      return
    }
    dispatch('setTimeslotData', {time, key: 'racers', value: 0})
    dispatch('setTimeslotData', {time, key: 'selected', value: false})
    dispatch('setTimeslotData', {time, key: 'parent', value: null})
    dispatch('setTimeslotData', {time, key: 'children', value: []})

    _.forOwn(children || [], childTime => {
      dispatch('deselectTimeslot', {time: childTime})
    })
  },

  setTimeslot({commit, dispatch, getters}, payload) {
    if (!getters.isHydratingData && getters.input('allowRaceSeparately') === false) {
        dispatch('cleanTimeslots')
    }

    const parentTime = payload.time
    let slot = getters.getSelectedTimeslot(parentTime)
    if (!slot) {
      commit(types.SET_TIMESLOT, getters.retrievedTimeslot(parentTime))
    }


    // ninja only
    const children = _.cloneDeep(payload.children || [])
    _.forOwn(children, time => {
      slot = getters.getSelectedTimeslot(time)
      if (!slot) {
        commit(types.SET_TIMESLOT, getters.retrievedTimeslot(time))
      }
    })


    // selected timestamp, payload.selected is here used during hydrating
    const now = !payload.selected || _.isBoolean(payload.selected) ? (new Date()).valueOf() : payload.selected

    dispatch('setTimeslotData', {time: parentTime, key: 'selected', value: now})
    dispatch('setTimeslotData', {time: parentTime, key: 'children', value: children})
    dispatch('setTimeslotData', {time: parentTime, key: 'parent', value: null})

    _.forOwn(children, time => {
      dispatch('setTimeslotData', {time, key: 'selected', value: now})
      dispatch('setTimeslotData', {time, key: 'children', value: []})
      dispatch('setTimeslotData', {time, key: 'parent', value: parentTime})
    })

    // when force setting of races is required
    const racers = payload.racers || null
    if (!_.isNull(racers)) {
      dispatch('setTimeslotData', {time: parentTime, key: 'racers', value: racers})
      _.forOwn(children, time => {
        dispatch('setTimeslotData', {time, key: 'racers', value: racers})
      })
    }

    // force setting of holds
    const holds = payload.holds || null
    if (holds) {
      _.forOwn(holds , (hold, time) => {
        dispatch('setTimeslotData', {time: time, key: 'hold', value: hold})
      })
    }
  },
  setTimeslotData({commit}, payload) {
    commit(types.SET_TIMESLOT_DATA, payload)
  },
  cleanTimeslots({commit, dispatch, getters}) {
    _.forOwn(getters.selectedAllTimeslots, item => {
      if (item) {
        dispatch('removeTimeslot', item)
      }
    })
    // commit(types.CLEAN_TIMESLOTS)
  },
  removeTimeslot({commit, dispatch, getters}, payload) {
    //
    if (!payload) {
      return
    }
    const children = _.clone(payload.children || [])
    const parentTime = payload.time
    // unhold
    const parent = getters.selectedAllTimeslots[parentTime]
    const holdId = _.get(parent || {}, 'hold.onlineBookingReservationsId')
    if (parent) {
      const holdIds = [];
      if (holdId) {
        holdIds.push(holdId)
      }
      dispatch('setTimeslotData', {time: parentTime, key: 'hold', value: _.merge({}, parent.hold, holdDefault)})

      if (children && children.length) {
        _.forOwn(children, time => {
          let child = getters.selectedAllTimeslots[time]
          let childHoldId = _.get(child || {}, 'hold.onlineBookingReservationsId')
          let resetHold = _.merge({}, child.hold, holdDefault)
          dispatch('setTimeslotData', {time: time, key: 'hold', value: resetHold})

          if (childHoldId) {
            holdIds.push(childHoldId)
          }
        });
      }
      if (holdIds.length) {
        ProviderService.unhold(holdIds)
      }
    }

    dispatch('setTimeslotData', {time: parentTime, key: 'selected', value: false})
    dispatch('setTimeslotData', {time: parentTime, key: 'racers', value: 0})
    dispatch('setTimeslotData', {time: parentTime, key: 'parent', value: null})
    dispatch('setTimeslotData', {time: parentTime, key: 'children', value: []})

    commit(types.UNSET_TIMESLOT, payload)

    _.forOwn(children, time => {
       dispatch('removeTimeslot', {time})
    })

  },
  updateTimeslotSelection({dispatch}, payload) {
    if (payload.selected) {
      dispatch('setTimeslot', payload)
    } else {
      dispatch('removeTimeslot', payload)
    }
  },
  unsetAllPlayers({dispatch, state, getters}) {
    _.forOwn(getters.selectedTimeslots, ({time}) => {
        dispatch('setTimeslotData', {time: time, key: 'racers', value: 0})
    })
  },
  setLocalCartItem({commit}, payload) {
    commit(types.SET_LOCAL_CART_ITEM, payload)
  },
  unsetLocalCartItem({commit}, payload) {
    commit(types.UNSET_LOCAL_CART_ITEM, payload)
  },
  clearLocalCart({commit}) {
    commit(types.CLEAR_LOCAL_CART_ITEMS)
  },
  enableSlotGrouping({commit}, payload) {
    commit(types.USE_SLOT_GROUPING, payload)
  },
  startHydratingData({commit}, payload) {
    commit(types.IS_HYDRATING_DATA, payload)
  },
  setProductAccessories({commit}, payload) {
    commit(types.SET_PRODUCT_ACCESSORIES, payload)
  },
  addRacerDetailsItem({commit}, data) {
    commit(types.ADD_RACER_DETAILS_ITEM, data)
  },
  updateRacerDetails({commit}, data) {
    commit(types.UPDATE_RACER_DETAILS_ITEM, data)
  },
  deleteRacerDetails({commit}, index) {
    commit(types.DELETE_RACER_DETAILS_ITEM, index)
  }
}

// getters
const getters = {
  // ...mapGetters(state.form),
  holdDefaults: state => holdDefault,
  productAccessories: state => state.productAccessories,
  updateAccessoriesCartItem(state, getters) {
    return function ({id, item, parentId}) {
      const items = {[item.id]: item}
      const cartItems = helpers.prepareAccessoriesCartItems(items, parentId, state.settings, state, getters)
      const newItem = _.first(_.values(cartItems))
      return newItem
    }
  },
  isHydratingData: state => state.isHydrating,
  isSlotGroupingEnabled: state => state.allowSlotGrouping,
  isUsingPackages: (state, getters) => getters.input('usePackages'),
  isRacingSeparately: (state, getters) => {
    return getters.input('raceSeparately') ==='yes' && getters.totalPlayers > 1
  },

  isNinjaRace: (state, getters) => getters.input('raceType') === 'ninja',

  raceTypes: state => state.raceTypes,
  raceEditItem: state => state.editItem,
  isRaceInEditMode: state => !!state.editItem,
  input(state, getters) {
    return function (item) {
      if (!item) {
        return state.form
      }
      return _.get(state.form, item)
    }
  },
  getSettings(state, getters) {
    return function (key, defaultValue) {
      return _.get(state.settings, key, defaultValue)
    }
  },

  filteringRaceProductIds(state, getters) {
    const type = state.form.raceType || 'pro'
    return supercharged.races[type].products || []
  },
  filteredSlotsByRaceType(state, getters) {
    return _.pickBy(getters.retrievedTimeslots || {}, ({karts = 0}) => karts > 0)
  },
  visibleSlots(state, getters) {
    const slots = getters.filteredSlotsByRaceType
    const racers = getters.totalPlayers || 0
    const hours  = state.allowSlotGrouping ? (state.form.numberOfHours || 1) : false

    const allow = state.form.allowRaceSeparately && ((state.form.raceSeparately  || 'no') === 'yes')
    if (hours === false && (!racers || allow)) {
      return slots
    }
    const filteredSlots = _.pickBy(slots, ({karts = 0}) => allow ? (karts > 0) : (karts >= racers))
    return filteredSlots
  },

  retrievedTimeslot(state, getters) {
    return function (time) {
      return getters.retrievedTimeslots[time]
      // return getters.retrievedTimeslots.a[time] ||  getters.retrievedTimeslots.e[time]
    }
  },
  selectedAllTimeslots: state => state.form.selectedSlots || {},
  numberOfSelectedAllTimeslots: (state, getters) => Object.keys(getters.selectedAllTimeslots).length,
  selectedTimeslots(state, getters) {
    return _.filter(getters.selectedAllTimeslots, ({racers}) => racers > 0 )
  },
  getSelectedTimeslot(state, getters) {
    return function (time) {
      return getters.selectedAllTimeslots[time]
    }
  },

  totalPlayers(state, getters) {
    return parseNumber(state.form.numberOfAdults)
  },
  totalRaces(state, getters) {
    return parseNumber(state.form.numberOfAdultRaces)
  },
  maxRacesPerPlayer(state, getters) {
    var maxRacer = _.maxBy(state.form.racerDetails, ({quantity}) => quantity)
    return maxRacer.quantity
  },

  totalPlayersGrouped(state, getters) {
    return {adult: parseNumber(state.form.numberOfAdults)}
  },
  totalRacersSlotted(state, getters) {
    return _.reduce(getters.selectedTimeslots, (total, {racers = 0}) => total + racers, 0)
  },
  totalRacesSlotted(state, getters) {
    return _.reduce(getters.selectedTimeslots, (total, {racers = 0}) => total + racers, 0)
  },
  totalRacesNotSlotted(state, getters) {
    return getters.totalRaces - getters.totalRacesSlotted
  },
  totalRacersSlottedGrouped(state, getters) {
    return _.reduce(getters.selectedTimeslots, (carry, {type, racers = 0}) => {
        carry[type] += racers
        return carry
      }, {'adult': 0})
  },
  totalRacersNotSlottedGrouped(state, getters) {
    const slotted = getters.totalRacersSlottedGrouped
    return {
      adult: max(0, parseNumber(state.form.numberOfAdults) - slotted.adult),
    }
  },
  totalRacersNotSlotted(state, getters) {
    return max(0, getters.totalPlayers - getters.totalRacersSlotted)
  },
  currentMaxSelectableRacesPerSlotForPackages(state, getters) {
      const matrix = state.form.racerRacesMatrix || []
      const noSetMatrix = matrix.filter(({filled}) => !filled)
      const highestItem = _.maxBy(noSetMatrix, ({max}) => max) || {}
      // console.log('get currentMaxSelectableRacesPerSlotForPackages', highestItem.max || 0);
      return highestItem.max || 0
  },

  maxAllowedJuniorRaces(state, getters) {
    return parseNumber(state.form.numberOfJuniorRaces)
  },
  maxAllowedAdultRaces(state, getters) {
    return parseNumber(state.form.numberOfAdultRaces)
  },
  maxAllowedRaces(state, getters) {
    return getters.maxAllowedAdultRaces + getters.maxAllowedJuniorRaces
  },

  numberOfRaces: (state, getters) => Object.keys(getters.selectedTimeslots).length,

  breakupOfRaces(state, getters) {

    const type = 'races'
    const racerDetails = state.form.racerDetails || []

    const date = DateTime.fromISO(getters.input('selectedDate')).toISODate()
    const allPackages = state.settings.races
    const packages = Object.keys(allPackages).sort((a, b) => b - a)

    let allRaces = racerDetails.map(racer => {
      return helpers.packageRacer(racer, {packages, state, getters})
    })

    const raceItems =  _.reduce(_.keys(allPackages), (raceItems, raceName) => {
      _.forOwn(allRaces, racer => {
        if (racer[raceName]) {
          raceItems[raceName] = (raceItems[raceName] || 0) + racer[raceName]
        }
      })
      return raceItems
    }, {});

    const races = _.reduce(raceItems, (races, quantity, key) => {
      if (quantity) {
        races.push({key, type, quantity, date})
      }
      return races
    }, [])

    return races
  },
  breakupOfReservations(state, getters) {
    const slots = getters.selectedTimeslots
    if (slots) {
      const date = DateTime.fromISO(getters.input('selectedDate')).toISODate()
      const adults = parseNumber(state.form.numberOfAdults)
      const totalPlayers = getters.totalPlayers
      const numberOfRaces = getters.numberOfRaces
      const info = {
        adults,
        numberOfRaces,
        date
      }

      const reservations = _.reduce(slots, (reservations, slot) => {
        const bookingItem = slot.item
        const rProduct = bookingItem.reservationProduct || {}
        const product_id = bookingItem.product_id
        const title = rProduct.title || 'Race Reservation'
        const id = bookingItem.originalProductId
        const meta = {
          ...(rProduct.meta || {}),
          type: slot.type,
          time: slot.time,
          racers: slot.racers,
          info
        }

        if (!reservations[product_id]) {
          reservations[product_id] = {
            product_id, title, key: id, type: raceType, quantity: parseNumber(slot.racers)
          }
        } else {
          reservations[product_id].quantity += slot.racers
        }

        reservations[product_id].meta = meta
        reservations[product_id].meta.slots = slots
        return reservations
      }, {})

      return Object.values(reservations)
    }

    return []
  },

  totalCostOfRaces(state, getters) {
    return getters.proposedRaces.reduce((total, {amount = 0}) => total + amount, 0)
  },

  proposedReservations(state, getters) {
    return helpers.getCartItem(getters.breakupOfReservations, {
    }, state.settings, state, getters)
  },
  proposedRaces(state, getters) {
    return helpers.getCartItem(getters.breakupOfRaces, {}, state.settings, state, getters)
  },
  proposedCartItems(state, getters) {
    const isNinja = getters.input('raceType') === 'ninja'
    const usePackages = getters.input('usePackages')
    if (isNinja || !usePackages) {
      return [...getters.proposedReservations]
    }
    return [...getters.proposedReservations, ...getters.proposedRaces]
  },
  proposedCart(state, getters) {
    const isNinja = getters.input('raceType') === 'ninja'
    if (isNinja) {
      return helpers.prepareUniversalNinjaCartItems(getters.selectedTimeslots, state.settings, state, getters)
    }
    return helpers.prepareUniversalCartItems(getters.proposedCartItems, state.settings, state, getters)
  },

  cartTotal(state, getters) {
    return getters.proposedCartItems.reduce((total, {amount = 0}) => total + amount, 0)
  },

  retrievedTimeslots : state => state.retrievedSlots,
  isRetrievingTimeslots: state => state.fetchingTimeslots,

  localRacesCartItems: state => state.cartItems,
}

// plugins
const plugins = []
// const plugins = [createPersistedState({
//     key: 'racewaybooking-shop',
//     subscriber: () => {
//       console.log(this.proposedCart)g(arguments)
//     }
// })]

const race = {namespaced, namespace, state, mutations, actions, getters, plugins}
export default race
